import axios from 'axios';
import { useEffect, useState, useContext } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import SpinnerPage from './SpinnerPage';
import BASE_API_URL from '../apis/index';
import {UserContext} from '../App';

const PrivateRoutes = () => {
  const {setUser} = useContext(UserContext);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true); // prevent rendering until checked

  useEffect(() => {
    const token = localStorage.getItem('authToken');

    if (!token) {
      navigate('/login');
      return;
    }

    axios.get(`${BASE_API_URL}/api/auth/verify-token`, {headers: 
      { Authorization: `Bearer ${token}`}
    }).then((res) => {
      if (res.data.status === 'ok') {
          setUser(res.data)
          setLoading(false);
        } else {
          navigate('/login');
        }
      }).catch((err) => {
        console.error('Token verification failed:', err);
        navigate('/login');
      });
  }, [navigate, setUser]);

  if (loading) return <SpinnerPage />;

  return <Outlet />;
};

export default PrivateRoutes;
